import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetPublicClassShareLinkResult {
  shareToken: string | null;
}

export const getPublicClassShareLinkAPI = async (classId: string) => {
  const response = await baseAPI.get<GetPublicClassShareLinkResult>(
    `/enrollments/${classId}/public-share-link`,
  );
  return response.data;
};

export function useGetPublicClassShareLink(classId: string) {
  return useQuery({
    queryKey: [KEYS.CLASSES, classId, 'public-share-link'],
    queryFn: () => getPublicClassShareLinkAPI(classId),
    enabled: classId.trim().length > 0,
  });
}
